import { FormProvider, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

import { FormField } from "components/form/FormField/FormField";
import { Select } from "components/ui/Select/Select";
import { useStaffMembers } from "features/practice/hooks/useStaffMembers";
import { onInvalidSubmit } from "utils/reportFormErrors";

const formSchema = z.object({
  staffMember: z.string().min(1, { message: "Please select a person." }),
});

export const AddNewChat = ({ chats, addNewChat }) => {
  const { data: staffMembers } = useStaffMembers();
  const staffThatHasNoActiveChat = staffMembers?.filter(
    (staff) => !chats.some((chat) => chat.staffId === staff.id)
  );

  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      staffMember: "",
    },
  });
  const staffMember = form.watch("staffMember");

  const handleFormSubmit = async (values) => {
    const selectedStaffMember = staffThatHasNoActiveChat?.find(
      (staff) => staff.id === Number(values.staffMember)
    );

    addNewChat(selectedStaffMember);
    form.reset();
  };

  return (
    <FormProvider {...form}>
      <form
        onSubmit={form.handleSubmit(handleFormSubmit, onInvalidSubmit("add-new-chat"))}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <FormField name="staffMember">
          <Select
            name="staffMember"
            placeholder="Select person..."
            options={(staffThatHasNoActiveChat || []).map((staff) => ({
              label: `${staff.active ? "🟢 " : "⚫ "}${staff.firstName} ${staff.lastName}${staff.staffRole ? ` (${staff.staffRole.toLowerCase()})` : ""}`,
              value: String(staff.id),
            }))}
            value={form.watch("staffMember")}
            onChange={(value) => form.setValue("staffMember", value)}
            fullWidth
          />
        </FormField>
        <button
          disabled={!staffMember}
          type="submit"
          style={{
            backgroundColor: staffMember ? "#1164a3" : "#4a4d52",
            color: "#fff",
            border: "none",
            fontSize: "0.875rem",
            cursor: staffMember ? "pointer" : "not-allowed",
            borderRadius: "6px",
            padding: "8px 12px",
            fontWeight: 500,
            opacity: staffMember ? 1 : 0.6,
          }}
        >
          Start conversation
        </button>
      </form>
    </FormProvider>
  );
};
